import { observable } from "mobx";
import type { EntityValidationRules } from "../../../services/validationService";
import DecimalRangeRequest from "../../decimalRangeRequest";
import { ApprovalState } from "../../approvalState";

export default class RefundsSearchFilter<TApprovalType = any> {
  @observable _approvalState?: ApprovalState;
  @observable approvedBy?: TApprovalType;
  @observable countryId?: string;
  @observable fullTextSearchEnabled? = false;
  @observable licensePlate?: string;
  @observable notApprovedBy?: TApprovalType;
  @observable officialRecordId?: string;
  @observable paidAmount?: number;
  @observable refundAmount?: DecimalRangeRequest;
  @observable refundPaymentTemplateId?: string;
  @observable variableSymbol?: number;
}

export const RefundsSearchFilterValidationRules: EntityValidationRules<RefundsSearchFilter> = {
  licensePlate: {
    isLicensePlate: {
      required: false,
    },
  },
  refundAmount: {
    isNumberRange: {
      min: 0,
    },
  },
  officialRecordId: {
    isLength: {
      min: 3,
      max: 50,
      optional: true,
    },
  },
};
